// Button that opens edit mode for all prompts, disabled with an explanation once the tracker is locked.
import { Pencil } from 'lucide-react'
import { Button } from '@/components/ui/button'
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/ui/tooltip'
import type { EditPromptsButtonProps } from './EditPromptsButton.types'

const LOCKED_MESSAGE =
  "This tracker is now measuring performance over time. Editing any prompt would corrupt your trend data. To change what's tracked, configure a new tracker."

export function EditPromptsButton({ state, onEdit }: EditPromptsButtonProps) {
  const button = (
    <Button
      type="button"
      variant="outline"
      size="sm"
      disabled={state === 'locked'}
      onClick={onEdit}
    >
      <Pencil className="size-3.5" /> Edit prompts
    </Button>
  )

  if (state === 'tuning') return button

  // A disabled button fires no pointer events, so the wrapper carries the tooltip.
  return (
    <TooltipProvider delayDuration={150}>
      <Tooltip>
        <TooltipTrigger asChild>
          <span className="inline-flex">{button}</span>
        </TooltipTrigger>
        <TooltipContent className="max-w-xs">{LOCKED_MESSAGE}</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  )
}
